import React from 'react';
import LottiePlayer from "lottie-react";
import NoDataFoundAnim from '../assets/animationicons/nodatafound.json';





const NoDataFound = ({ heading, nodatatext }) => {
    return <div className="no-data-found">

        <div className="textdata d-flex align-items-center justify-content-center flex-column mt-5">
            <LottiePlayer
                animationData={NoDataFoundAnim}
                style={{ height: 150, marginBottom: 0 , border:"none"}}
            // autoplay = {false}
            // loop = {false}

            />
            <h5 style={{ marginTop: '-10px', fontWeight:"500" , border:"none" }}>{nodatatext}</h5>
        </div>
    </div>
}

// export pr

export default NoDataFound;
